namespace TabAurous.ItemFieldHelper {

    export function SalesBOMFields(Dialog: any) {

        q.showAndDisableField(Dialog.form.ProductTypeId);
        q.showAndDisableField(Dialog.form.BOMProductId);
        q.showAndDisableField(Dialog.form.Weight);
        q.showAndDisableField(Dialog.form.CalcOnId);

        switch (Dialog.form.ItemTypeId.value) {

            case 105: {
                q.hideField(Dialog.form.KaratId);
                q.hideField(Dialog.form.Purity);
                q.hideField(Dialog.form.MetalColorId);
                q.hideField(Dialog.form.Purity);
                q.hideField(Dialog.form.PureWeight);
                //q.hideField(Dialog.form.GrossWeight);
                q.showAndDisableField(Dialog.form.ShapeId);
                q.showAndDisableField(Dialog.form.Pieces);
                q.showAndDisableField(Dialog.form.QualityId);
                q.showAndDisableField(Dialog.form.StoneColorId);
                q.showAndDisableField(Dialog.form.StoneSizeId);
                q.showAndDisableField(Dialog.form.SieveId);
                q.showAndDisableField(Dialog.form.CategoryId);
                q.showAndDisableField(Dialog.form.SubCategoryId);
                q.showAndEnableField(Dialog.form.PointerWeight);
                q.showAndDisableField(Dialog.form.SettingId);

                switch (parseInt(Dialog.form.CategoryId.value)) {
                    case 1:
                    case 3:
                    case 4:
                        q.hideField(Dialog.form.StoneCutId);
                        q.hideField(Dialog.form.StonePolishId);
                        q.hideField(Dialog.form.StoneSymmetryId);
                        q.hideField(Dialog.form.StoneFluorescenceId);
                        q.hideField(Dialog.form.StoneCuletId);
                        q.hideField(Dialog.form.StoneGirdleId);
                        q.hideField(Dialog.form.StoneTable);
                        q.hideField(Dialog.form.StoneDepth);
                        q.hideField(Dialog.form.CertificateNo);
                        //q.hideEditorCategory(Dialog.form.StoneCuletId);
                        break;
                    case 2:
                        q.showAndDisableField(Dialog.form.StoneCutId);
                        q.showAndDisableField(Dialog.form.StonePolishId);
                        q.showAndDisableField(Dialog.form.StoneSymmetryId);
                        q.showAndDisableField(Dialog.form.StoneFluorescenceId);
                        q.showAndDisableField(Dialog.form.StoneCuletId);
                        q.showAndDisableField(Dialog.form.StoneGirdleId);
                        q.showAndDisableField(Dialog.form.StoneTable);
                        q.showAndDisableField(Dialog.form.StoneDepth);
                        q.showAndDisableField(Dialog.form.CertificateNo);
                        q.showAndDisableField(Dialog.form.Pieces);
                        q.showAndDisableField(Dialog.form.Weight);
                        //q.showAndSetRequiredField(Dialog.form.Lab);

                        break;
                    default:
                        q.hideField(Dialog.form.StoneCutId);
                        q.hideField(Dialog.form.StonePolishId);
                        q.hideField(Dialog.form.StoneSymmetryId);
                        q.hideField(Dialog.form.StoneFluorescenceId);
                        q.hideField(Dialog.form.StoneCuletId);
                        q.hideField(Dialog.form.StoneGirdleId);
                        q.hideField(Dialog.form.StoneTable);
                        q.hideField(Dialog.form.StoneDepth);
                        q.hideField(Dialog.form.CertificateNo);
                        break;
                }

                break;
            }
            case 104: {
                q.showAndDisableField(Dialog.form.KaratId);
                q.showAndDisableField(Dialog.form.MetalColorId);
                q.showAndDisableField(Dialog.form.KaratId); 
                q.showAndDisableField(Dialog.form.Purity);
                q.showAndDisableField(Dialog.form.PureWeight);
                //q.showAndEnableField(Dialog.form.GrossWeight);

                q.hideField(Dialog.form.ShapeId);
                q.hideField(Dialog.form.QualityId);
                q.hideField(Dialog.form.StoneColorId);
                q.hideField(Dialog.form.StoneSizeId);
                q.hideField(Dialog.form.SieveId);
                q.hideField(Dialog.form.PointerWeight);
                q.hideField(Dialog.form.Pieces);
                q.hideField(Dialog.form.CategoryId);
                q.hideField(Dialog.form.SubCategoryId);
                q.hideField(Dialog.form.CertificateNo);
                q.hideField(Dialog.form.SettingId);
                Dialog.form.CategoryId.value == "7" ? q.showAndEnableField(Dialog.form.Pieces) : q.hideField(Dialog.form.Pieces);
                break;
            }

            default: {
                q.hideField(Dialog.form.KaratId);
                q.hideField(Dialog.form.Purity);
                q.hideField(Dialog.form.MetalColorId);
                q.hideField(Dialog.form.ShapeId);
                q.hideField(Dialog.form.QualityId);
                q.hideField(Dialog.form.StoneColorId);
                q.hideField(Dialog.form.StoneSizeId);
                q.hideField(Dialog.form.SieveId);
                q.hideField(Dialog.form.PointerWeight);
                break;
            }
        }
    }

    export function PurchaseBOMFields(Dialog: any) {

        switch (Dialog.form.ItemTypeId.value) {

            case 105: {
                q.hideField(Dialog.form.KaratId);
                q.hideField(Dialog.form.Purity);
                q.hideField(Dialog.form.MetalColorId);
                q.hideField(Dialog.form.Purity);
                q.hideField(Dialog.form.PureWeight);
                q.hideField(Dialog.form.GrossWeight);
                //Dialog.isReadOnly ? q.showAndDisableField(Dialog.form.Pieces): q.showAndSetRequiredField(Dialog.form.Pieces);
                Dialog.isReadOnly ? q.showAndDisableField(Dialog.form.SettingId):q.showAndSetRequiredField(Dialog.form.SettingId);
                Dialog.isReadOnly ? q.showAndDisableField(Dialog.form.PointerWeight) : q.showAndEnableField(Dialog.form.PointerWeight);
                q.showAndSetRequiredField(Dialog.form.Pieces);

                if (Dialog.IsConfigurable) {
                    q.showAndSetRequiredField(Dialog.form.ShapeId);
                    q.showAndSetRequiredField(Dialog.form.QualityId);
                    q.showAndSetRequiredField(Dialog.form.StoneColorId);
                    q.showAndSetRequiredField(Dialog.form.StoneSizeId);
                    q.showAndSetRequiredField(Dialog.form.SieveId);
                    q.showAndEnableField(Dialog.form.PointerWeight);
                    q.showAndSetRequiredField(Dialog.form.CategoryId);
                    q.showAndSetRequiredField(Dialog.form.SubCategoryId);
                }
                else {
                    q.showAndDisableField(Dialog.form.ShapeId);
                    q.showAndDisableField(Dialog.form.QualityId);
                    q.showAndDisableField(Dialog.form.StoneColorId);
                    q.showAndDisableField(Dialog.form.StoneSizeId);
                    q.showAndDisableField(Dialog.form.SieveId);
                    q.showAndEnableField(Dialog.form.PointerWeight);
                    q.showAndDisableField(Dialog.form.CategoryId);
                    q.showAndDisableField(Dialog.form.SubCategoryId);

                }
                

                switch (parseInt(Dialog.form.CategoryId.value)) {
                    case 1:
                    case 3:
                    case 4:
                        q.hideField(Dialog.form.StoneCutId);
                        q.hideField(Dialog.form.StonePolishId);
                        q.hideField(Dialog.form.StoneSymmetryId);
                        q.hideField(Dialog.form.StoneFluorescenceId);
                        q.hideField(Dialog.form.StoneCuletId);
                        q.hideField(Dialog.form.StoneGirdleId);
                        q.hideField(Dialog.form.StoneTable);
                        q.hideField(Dialog.form.StoneDepth);
                        q.hideField(Dialog.form.CertificateNo);
                        q.hideField(Dialog.form.Lab);
                        break;
                    case 2:
                        q.showAndSetRequiredField(Dialog.form.StoneCutId);
                        q.showAndSetRequiredField(Dialog.form.StonePolishId);
                        q.showAndSetRequiredField(Dialog.form.StoneSymmetryId);
                        q.showAndSetRequiredField(Dialog.form.StoneFluorescenceId);
                        q.showAndSetRequiredField(Dialog.form.StoneCuletId);
                        q.showAndSetRequiredField(Dialog.form.StoneGirdleId);
                        q.showAndSetRequiredField(Dialog.form.StoneTable);
                        q.showAndSetRequiredField(Dialog.form.StoneDepth);
                        q.showAndSetRequiredField(Dialog.form.CertificateNo);
                        q.showAndSetRequiredField(Dialog.form.Pieces);
                        q.showAndSetRequiredField(Dialog.form.Weight);
                        q.showAndSetRequiredField(Dialog.form.Lab);

                        break;
                }

                break;
            }
            case 104: {
                Dialog.IsConfigurable ? q.showAndSetRequiredField(Dialog.form.KaratId) : q.showAndDisableField(Dialog.form.KaratId);
                Dialog.IsConfigurable ? q.showAndSetRequiredField(Dialog.form.MetalColorId) : q.showAndDisableField(Dialog.form.MetalColorId);
                q.showAndSetRequiredField(Dialog.form.Purity);
                q.showAndDisableField(Dialog.form.PureWeight);
                if (Dialog.form.GrossWeight != undefined)
                    q.showAndEnableField(Dialog.form.GrossWeight);

                q.hideField(Dialog.form.ShapeId);
                q.hideField(Dialog.form.QualityId);
                q.hideField(Dialog.form.StoneColorId);
                q.hideField(Dialog.form.StoneSizeId);
                q.hideField(Dialog.form.SieveId);
                q.hideField(Dialog.form.PointerWeight);
                q.hideField(Dialog.form.Pieces);
                q.hideField(Dialog.form.CategoryId);
                q.hideField(Dialog.form.SubCategoryId);
                q.hideField(Dialog.form.CertificateNo);
                q.hideField(Dialog.form.SettingId);
                Dialog.form.CategoryId.value == "7" ? q.showAndEnableField(Dialog.form.Pieces) : q.hideField(Dialog.form.Pieces);
                break;
            }

            default: {
                q.hideField(Dialog.form.KaratId);
                q.hideField(Dialog.form.Purity);
                q.hideField(Dialog.form.MetalColorId);
                q.hideField(Dialog.form.ShapeId);
                q.hideField(Dialog.form.QualityId);
                q.hideField(Dialog.form.StoneColorId);
                q.hideField(Dialog.form.StoneSizeId);
                q.hideField(Dialog.form.SieveId);
                q.hideField(Dialog.form.PointerWeight);
                break;
            }
        }

        Dialog.element.find('sup').toggle(Dialog.isReadOnly);
        for (let editor in Dialog.form) {
            if (Dialog.form[editor].widgetName) {

                try {
                    Serenity.EditorUtils.setReadOnly(Dialog.form[editor], Dialog.isReadOnly);
                } catch { }
            }
        }
    }

    function setMF(Dialog: any){
        let useMF
        Administration.ConfigurationService.List({ Code: 1022 }, response => { useMF = q.ToBool(response.Entities[0].Value) }, { async: false });

        if (useMF) {
            q.showAndEnableField(Dialog.form.MF);
            q.showAndEnableField(Dialog.form.MFAmount);
            q.showAndEnableField(Dialog.form.ExportPieces);
        }

    }

    function setFGFields(Dialog: any, VoucherId: number) {
        if (Dialog.entity.ProductId > 0) {
            q.showAndDisableField(Dialog.form.CategoryId);
            q.showAndDisableField(Dialog.form.SubCategoryId);
            q.showAndDisableField(Dialog.form.BrandId);
            q.showAndDisableField(Dialog.form.CollectionId);
            q.showAndDisableField(Dialog.form.SuperTypeId);
            q.showAndDisableField(Dialog.form.HasBom);
            q.showAndDisableField(Dialog.form.ProductCode);
            q.showAndDisableField(Dialog.form.ProductName);
            q.showAndDisableField(Dialog.form.ProductTypeId);
            q.showAndDisableField(Dialog.form.CalcOnId);
            q.showAndDisableField(Dialog.form.CalcUnitId);
        }
        else {
            q.showAndSetRequiredField(Dialog.form.CategoryId);
            q.showAndSetRequiredField(Dialog.form.SubCategoryId);
            q.showAndSetRequiredField(Dialog.form.BrandId);
            q.showAndSetRequiredField(Dialog.form.CollectionId);
            q.showAndSetRequiredField(Dialog.form.SuperTypeId);
            q.showAndEnableField(Dialog.form.HasBom)
            q.showAndSetRequiredField(Dialog.form.ProductCode);
            q.showAndSetRequiredField(Dialog.form.ProductName);
            q.showAndSetRequiredField(Dialog.form.ProductTypeId);
            q.showAndSetRequiredField(Dialog.form.CalcOnId);
            q.showAndSetRequiredField(Dialog.form.CalcUnitId);

        }
        q.showAndEnableField(Dialog.form.ProductSizeId);
        q.hideEditorTab(Dialog.form.BOMDetails, false);
        q.hideEditorTab(Dialog.form.ImageName, false);
        q.showAndDisableField(Dialog.form.UnitLabour);
        q.showAndDisableField(Dialog.form.NetWeight);
        //q.showAndDisableField(Dialog.form.OtherWeight);
        //q.showAndDisableField(Dialog.form.OtherPieces);
        q.showAndDisableField(Dialog.form.WstPer);
        q.showAndDisableField(Dialog.form.WstWt);
        setFGHasBom(Dialog);
        q.hideField(Dialog.form.MetalColorId);
        q.hideField(Dialog.form.ShapeId);
        q.hideField(Dialog.form.QualityId);
        q.hideField(Dialog.form.StoneColorId);
        q.hideField(Dialog.form.StoneSizeId);
        q.hideField(Dialog.form.SieveId);
        q.hideField(Dialog.form.PointerWeight);
        q.hideField(Dialog.form.StoneCutId);
        q.hideField(Dialog.form.StonePolishId);
        q.hideField(Dialog.form.StoneSymmetryId);
        q.hideField(Dialog.form.StoneFluorescenceId);
        q.hideField(Dialog.form.StoneCuletId);
        q.hideField(Dialog.form.StoneGirdleId);
        q.hideField(Dialog.form.StoneTable);
        q.hideField(Dialog.form.StoneDepth);
        q.hideField(Dialog.form.LotNo);
        q.showAndEnableField(Dialog.form.RefNo);

        q.showAndEnableField(Dialog.form.StampId);

        switch (VoucherId) {
            case 53:
            case 54:
                q.hideField(Dialog.form.Line_No);
                break;

            case 13:
            case 31:
                q.showAndDisableField(Dialog.form.Line_No);
                q.showAndEnableField(Dialog.form.Hallmark);
                q.showAndEnableField(Dialog.form.HUID);
                q.showAndEnableField(Dialog.form.CertificateNo);
                q.showAndEnableField(Dialog.form.Lab);
                break;
        }

    }

    function setFGHasBom(Dialog: any) {
        Dialog.form.HasBom.value ? q.showFieldAndCategory(Dialog.form.BOMDetails) : q.showFieldAndCategory(Dialog.form.BOMDetails, false);
        Dialog.form.HasBom.value ? q.hideField(Dialog.form.Purity) : parseInt(Dialog.form.KaratId.value) > 0 ? q.showAndSetRequiredField(Dialog.form.Purity) : q.showAndDisableField(Dialog.form.Purity);
        Dialog.form.HasBom.value ? q.hideField(Dialog.form.PureWeight) : q.showAndDisableField(Dialog.form.PureWeight);
        Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.Weight) : q.showAndEnableField(Dialog.form.Weight);
        Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.StoneWeight) : q.showAndEnableField(Dialog.form.StoneWeight);
        Dialog.form.HasBom.value ? q.hideField(Dialog.form.MetalAmount) : q.showAndEnableField(Dialog.form.MetalAmount);
        Dialog.form.HasBom.value ? q.hideField(Dialog.form.StoneAmount) : q.showAndEnableField(Dialog.form.StoneAmount);
        Dialog.form.HasBom.value ? q.hideField(Dialog.form.StoneRate) : q.showAndEnableField(Dialog.form.StoneRate);
        Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.DiamondPieces) : q.hideField(Dialog.form.DiamondPieces);
        Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.DiamondWeight) : q.hideField(Dialog.form.DiamondWeight);
        Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.StonePieces) : q.hideField(Dialog.form.StonePieces);

        Dialog.form.HasBom.value ? Dialog.form.CalcOnId.value = "3" : Dialog.form.CalcOnId.value = "4";
        Dialog.form.HasBom.value ? Dialog.form.CalcUnitId.value = "6" : Dialog.form.CalcUnitId.value = "7";
        Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.MetalId) : q.showAndSetRequiredField(Dialog.form.MetalId);
        parseInt(Dialog.form.MetalId.value) > 0 ? q.showAndSetRequiredField(Dialog.form.KaratId) : q.showAndDisableField(Dialog.form.KaratId);
        !Dialog.form.HasBom.value ? parseInt(Dialog.form.KaratId.value) > 0 ? q.showAndSetRequiredField(Dialog.form.UnitRate) : q.showAndDisableField(Dialog.form.UnitRate) : q.showAndDisableField(Dialog.form.UnitRate);
        if (!Dialog.form.HasBom.value) {
            Dialog.form.Weight.value = Dialog.entity.Weight == 0 ? 1 : Dialog.entity.Weight;
            q.HideCategoryLable(Dialog.element)
        }

    }

    function setRMFiels(Dialog: any, isSales: boolean) {
        q.showAndSetRequiredField(Dialog.form.UnitRate);
        q.hideField(Dialog.form.BOMDetails);
        q.hideField(Dialog.form.BrandId);
        q.hideField(Dialog.form.CollectionId);
        q.hideField(Dialog.form.SuperTypeId);
        q.hideField(Dialog.form.ProductSizeId);
        q.hideField(Dialog.form.UnitLabour);
        q.hideField(Dialog.form.NetWeight);
        q.hideField(Dialog.form.DiamondPieces);
        q.hideField(Dialog.form.DiamondWeight);
        q.hideField(Dialog.form.StonePieces);
        q.hideField(Dialog.form.StoneWeight);
        q.hideField(Dialog.form.OtherWeight);
        q.hideField(Dialog.form.OtherPieces);
        q.hideField(Dialog.form.WstPer);
        q.hideField(Dialog.form.WstWt);
        q.hideField(Dialog.form.Line_No);
        q.hideField(Dialog.form.SKU);
        q.hideField(Dialog.form.Hallmark);
        q.hideField(Dialog.form.HasBom);
        q.hideEditorTab(Dialog.form.BOMDetails);
        q.hideEditorTab(Dialog.form.ImageName);
        Dialog.form.HasBom.value == false;

        // **** Metal Fields **** //
        switch (Dialog.form.ProductTypeId.value) {
            case "5":
            case "6":
            case "7":
                setMetalfields(Dialog, isSales);
                break;
            case "11":
            case "12":
            case "15":
                setStoneFields(Dialog, isSales);
                break;
        }

    }

    function setMetalfields(Dialog: any, isSales: boolean) {
        if (isSales) {
            q.showAndDisableField(Dialog.form.KaratId);
            q.showAndDisableField(Dialog.form.MetalColorId);
            q.showAndDisableField(Dialog.form.Purity);
            q.showAndDisableField(Dialog.form.PureWeight);

        } else {
            q.showAndSetRequiredField(Dialog.form.KaratId);
            q.showAndSetRequiredField(Dialog.form.MetalColorId);
            q.showAndSetRequiredField(Dialog.form.Purity);
            q.showAndDisableField(Dialog.form.PureWeight);
            Dialog.form.CalcOnId.value = "4";
            Dialog.form.CalcUnitId.value = "7"
            Dialog.form.ItemTypeId.value = 104;
        }

        q.hideField(Dialog.form.ShapeId);
        q.hideField(Dialog.form.QualityId);
        q.hideField(Dialog.form.StoneColorId);
        q.hideField(Dialog.form.StoneSizeId);
        q.hideField(Dialog.form.SieveId);
        q.hideField(Dialog.form.PointerWeight);
        q.hideField(Dialog.ExportPieces);
        q.hideField(Dialog.form.SubCategoryId);
        q.hideField(Dialog.form.ShapeId);
        q.hideField(Dialog.form.SuperTypeId);
        q.hideField(Dialog.form.QualityId);
        q.hideField(Dialog.form.StoneColorId);
        q.hideField(Dialog.form.StoneSizeId);
        q.hideField(Dialog.form.SieveId);
        q.hideField(Dialog.form.Pieces);
        q.hideField(Dialog.form.SubCategoryId);
        q.hideField(Dialog.form.StoneCutId);
        q.hideField(Dialog.form.StonePolishId);
        q.hideField(Dialog.form.StoneSymmetryId);
        q.hideField(Dialog.form.StoneFluorescenceId);
        q.hideField(Dialog.form.StoneCuletId);
        q.hideField(Dialog.form.StoneGirdleId);
        q.hideField(Dialog.form.StoneTable);
        q.hideField(Dialog.form.StoneDepth);
        q.hideField(Dialog.form.Pieces);
        q.hideField(Dialog.form.CategoryId);
        q.hideField(Dialog.form.LotNo);
        Dialog.form.CategoryId.value == "7" ? q.showAndEnableField(Dialog.form.Pieces) : q.hideField(Dialog.form.Pieces);
    }

    function setStoneFields(Dialog: any, isSales: boolean) {
        q.hideField(Dialog.form.KaratId);
        q.hideField(Dialog.form.MetalColorId);
        q.hideField(Dialog.form.MetalId);
        q.hideField(Dialog.form.Purity);
        q.hideField(Dialog.form.PureWeight)
        q.hideField(Dialog.form.Purity);
        q.showAndSetRequiredField(Dialog.form.Pieces);
        if (isSales) {
            q.showAndDisableField(Dialog.form.QualityId);
            q.showAndDisableField(Dialog.form.SieveId);
            q.showAndEnableField(Dialog.form.PointerWeight);
            q.showAndDisableField(Dialog.form.StoneColorId);
            q.showAndDisableField(Dialog.form.StoneSizeId);
            q.showAndDisableField(Dialog.form.ShapeId);

        }
        else {
            q.showAndSetRequiredField(Dialog.form.QualityId);
            q.showAndSetRequiredField(Dialog.form.SieveId);
            q.showAndSetRequiredField(Dialog.form.StoneColorId);
            q.showAndSetRequiredField(Dialog.form.StoneSizeId);
            q.showAndEnableField(Dialog.form.PointerWeight);
            Dialog.form.CalcOnId.value = "5";
            Dialog.form.CalcUnitId.value = "8"
            q.showAndDisableField(Dialog.form.LotNo);
            Dialog.form.ItemTypeId.value = 105;            
        }
        switch (parseInt(Dialog.form.CategoryId.value)) {
            case 1:
            case 3:
            case 4:
            case 9:
                q.hideField(Dialog.form.StoneCutId);
                q.hideField(Dialog.form.StonePolishId);
                q.hideField(Dialog.form.StoneSymmetryId);
                q.hideField(Dialog.form.StoneFluorescenceId);
                q.hideField(Dialog.form.StoneCuletId);
                q.hideField(Dialog.form.StoneGirdleId);
                q.hideField(Dialog.form.StoneTable);
                q.hideField(Dialog.form.StoneDepth);
                q.hideField(Dialog.form.CertificateNo);
                break;
            case 2:
                if (isSales) {
                    q.showAndDisableField(Dialog.form.StoneCutId);
                    q.showAndDisableField(Dialog.form.StonePolishId);
                    q.showAndDisableField(Dialog.form.StoneSymmetryId);
                    q.showAndDisableField(Dialog.form.StoneFluorescenceId);
                    q.showAndDisableField(Dialog.form.StoneCuletId);
                    q.showAndDisableField(Dialog.form.StoneGirdleId);
                    q.showAndDisableField(Dialog.form.StoneTable);
                    q.showAndDisableField(Dialog.form.StoneDepth);
                    q.showAndDisableField(Dialog.form.CertificateNo);
                    q.showAndDisableField(Dialog.form.Pieces);
                    q.showAndDisableField(Dialog.form.Weight);
                    q.showAndDisableField(Dialog.form.Lab);
                }
                else {
                    q.showAndSetRequiredField(Dialog.form.StoneCutId);
                    q.showAndSetRequiredField(Dialog.form.StonePolishId);
                    q.showAndSetRequiredField(Dialog.form.StoneSymmetryId);
                    q.showAndSetRequiredField(Dialog.form.StoneFluorescenceId);
                    q.showAndSetRequiredField(Dialog.form.StoneCuletId);
                    q.showAndSetRequiredField(Dialog.form.StoneGirdleId);
                    q.showAndSetRequiredField(Dialog.form.StoneTable);
                    q.showAndSetRequiredField(Dialog.form.StoneDepth);
                    q.showAndSetRequiredField(Dialog.form.CertificateNo);
                    q.showAndSetRequiredField(Dialog.form.Pieces);
                    q.showAndSetRequiredField(Dialog.form.Weight);
                    q.showAndSetRequiredField(Dialog.form.Lab);
                }
                break;
        }
        Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.CategoryId) : q.showAndSetRequiredField(Dialog.form.CategoryId);
        Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.SubCategoryId) : q.showAndSetRequiredField(Dialog.form.SubCategoryId);
        Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ShapeId) : q.showAndSetRequiredField(Dialog.form.ShapeId);
    }

    export function PurchaseItemFields(Dialog: any, VoucherId: number) {
         

        setMF(Dialog);
        Dialog.entity.ItemTypeId != 101 ? setRMFiels(Dialog, false): setFGFields(Dialog, VoucherId);
        Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ProductCode) : q.showAndSetRequiredField(Dialog.form.ProductCode);
        Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ProductName) : q.showAndSetRequiredField(Dialog.form.ProductName);
        Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ProductTypeId) : q.showAndSetRequiredField(Dialog.form.ProductTypeId);
        Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.CalcOnId) : q.showAndSetRequiredField(Dialog.form.CalcOnId);
        Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.CalcUnitId) : q.showAndSetRequiredField(Dialog.form.CalcUnitId);
        Dialog.element.find('sup').toggle(Dialog.isReadOnly);
        for (let editor in Dialog.form) {
            if (Dialog.form[editor].widgetName) {

                try {
                    Serenity.EditorUtils.setReadOnly(Dialog.form[editor], Dialog.isReadOnly);
                } catch { }
            }
        }
    }

    export function SalesItemFields(Dialog: any, VoucherId: number) {
         
        setMF(Dialog);

        //Dialog.form.ProductId.value == undefined ? Dialog.entity.HasBom = false : Dialog.form.HasBom.value = true;
        // **** Hide Jewellery Fields **** //
        if (Dialog.entity.ItemTypeId != 101) {

            Serenity.EditorUtils.setReadonly(Dialog.form.UnitRate.element, false);
            q.hideField(Dialog.form.BOMDetails);
            q.hideField(Dialog.form.BrandId);
            q.hideField(Dialog.form.CollectionId);
            q.hideField(Dialog.form.SuperTypeId);
            q.hideField(Dialog.form.ProductSizeId);
            q.hideField(Dialog.form.UnitLabour);
            q.hideField(Dialog.form.NetWeight);
            q.hideField(Dialog.form.DiamondPieces);
            q.hideField(Dialog.form.DiamondWeight);
            q.hideField(Dialog.form.StonePieces);
            q.hideField(Dialog.form.StoneWeight);
            q.hideField(Dialog.form.OtherWeight);
            q.hideField(Dialog.form.OtherPieces);
            q.hideField(Dialog.form.StoneRate);
            q.hideField(Dialog.form.OtherRate);
            q.hideField(Dialog.form.WstPer);
            q.hideField(Dialog.form.WstWt);
            q.hideField(Dialog.form.Line_No);
            q.hideField(Dialog.form.SKU);
            q.hideField(Dialog.form.CategoryId);
            q.hideField(Dialog.form.HasBom);
            q.hideField(Dialog.form.Hallmark);
            q.hideField(Dialog.form.HUID);
            q.hideEditorTab(Dialog.form.BOMDetails);
            q.hideEditorTab(Dialog.form.ImageName);
            Dialog.form.HasBom.value == false;

            // **** Metal Fields **** //
            if (Dialog.form.ProductTypeId.value == "5" || Dialog.form.ProductTypeId.value == "6" || Dialog.form.ProductTypeId.value == "7") {
                q.showAndDisableField(Dialog.form.KaratId);
                q.showAndDisableField(Dialog.form.MetalColorId);
                q.showAndDisableField(Dialog.form.Purity);
                q.showAndDisableField(Dialog.form.PureWeight);
                q.hideField(Dialog.form.ShapeId);
                q.hideField(Dialog.form.QualityId);
                q.hideField(Dialog.form.StoneColorId);
                q.hideField(Dialog.form.StoneSizeId);
                q.hideField(Dialog.form.SieveId);
                q.hideField(Dialog.form.PointerWeight);
                q.hideField(Dialog.form.Pieces);
                q.hideField(Dialog.form.SubCategoryId);
                q.hideField(Dialog.form.LotNo);

            }

            // **** Stone Fields **** //
            if (Dialog.form.ProductTypeId.value == "11" || Dialog.form.ProductTypeId.value == "12" || Dialog.form.ProductTypeId.value == "13") {
                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.SubCategoryId) : q.showAndSetRequiredField(Dialog.form.SubCategoryId);
                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ShapeId) : q.showAndSetRequiredField(Dialog.form.ShapeId);
                q.showAndDisableField(Dialog.form.QualityId);
                q.showAndDisableField(Dialog.form.SieveId);
                q.showAndDisableField(Dialog.form.StoneColorId);
                q.showAndDisableField(Dialog.form.StoneSizeId);
                q.showAndDisableField(Dialog.form.LotNo);
                q.showAndEnableField(Dialog.form.PointerWeight);
                q.hideField(Dialog.form.KaratId);
                q.hideField(Dialog.form.MetalColorId);
                q.hideField(Dialog.form.Purity);

                q.showAndEnableField(Dialog.form.Pieces);
                q.showAndEnableField(Dialog.form.Weight);
                q.hideField(Dialog.form.PureWeight)
                q.hideField(Dialog.form.Purity);
                Dialog.form.CalcOnId.value = "5";
                Dialog.form.CalcUnitId.value = "8"

                switch (parseInt(Dialog.form.CategoryId.value)) {
                    case 1:
                    case 3:
                    case 4:
                        q.hideField(Dialog.form.StoneCutId);
                        q.hideField(Dialog.form.StonePolishId);
                        q.hideField(Dialog.form.StoneSymmetryId);
                        q.hideField(Dialog.form.StoneFluorescenceId);
                        q.hideField(Dialog.form.StoneCuletId);
                        q.hideField(Dialog.form.StoneGirdleId);
                        q.hideField(Dialog.form.StoneTable);
                        q.hideField(Dialog.form.StoneDepth);
                        q.hideField(Dialog.form.CertificateNo);
                        break;
                    case 2:
                        q.showAndDisableField(Dialog.form.StoneCutId);
                        q.showAndDisableField(Dialog.form.StonePolishId);
                        q.showAndDisableField(Dialog.form.StoneSymmetryId);
                        q.showAndDisableField(Dialog.form.StoneFluorescenceId);
                        q.showAndDisableField(Dialog.form.StoneCuletId);
                        q.showAndDisableField(Dialog.form.StoneGirdleId);
                        q.showAndDisableField(Dialog.form.StoneTable);
                        q.showAndDisableField(Dialog.form.StoneDepth);
                        q.showAndDisableField(Dialog.form.CertificateNo);
                        q.showAndDisableField(Dialog.form.Pieces);
                        q.showAndDisableField(Dialog.form.Weight);
                        q.showAndDisableField(Dialog.form.Lab);
                        break;
                }

                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.CategoryId) : q.showAndSetRequiredField(Dialog.form.CategoryId);
                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.SubCategoryId) : q.showAndSetRequiredField(Dialog.form.SubCategoryId);
                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ShapeId) : q.showAndSetRequiredField(Dialog.form.ShapeId);
            }
        }
        else {
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.CategoryId) : q.showAndSetRequiredField(Dialog.form.CategoryId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.SubCategoryId) : q.showAndSetRequiredField(Dialog.form.SubCategoryId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.BrandId) : q.showAndSetRequiredField(Dialog.form.BrandId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.CollectionId) : q.showAndSetRequiredField(Dialog.form.CollectionId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.SuperTypeId) : q.showAndSetRequiredField(Dialog.form.SuperTypeId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ProductSizeId) : q.showAndSetRequiredField(Dialog.form.ProductSizeId);
            Dialog.entity.ProductId > 0 ? Dialog.form.HasBom.value == true ? q.showAndDisableField(Dialog.form.HasBom) : q.hideField(Dialog.form.HasBom) : q.showAndEnableField(Dialog.form.HasBom);

            Dialog.form.HasBom.value ? q.showFieldAndCategory(Dialog.form.BOMDetails) : q.showFieldAndCategory(Dialog.form.BOMDetails, false);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.Purity) : q.showAndDisableField(Dialog.form.Purity);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.PureWeight) : q.showAndDisableField(Dialog.form.PureWeight);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.HasBom) : q.showAndEnableField(Dialog.form.HasBom);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.StoneWeight) : q.showAndEnableField(Dialog.form.StoneWeight);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.MetalAmount) : q.showAndEnableField(Dialog.form.MetalAmount);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.StoneAmount) : q.showAndEnableField(Dialog.form.StoneAmount);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.StoneRate) : q.showAndSetRequiredField(Dialog.form.StoneRate);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.DiamondPieces) : q.hideField(Dialog.form.DiamondPieces);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.DiamondWeight) : q.hideField(Dialog.form.DiamondWeight);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.StonePieces) : q.hideField(Dialog.form.StonePieces);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.UnitRate) : q.showAndSetRequiredField(Dialog.form.UnitRate);

            Q.isEmptyOrNull(Dialog.form.SKU.value) ? q.showAndEnableField(Dialog.form.Pieces) : q.showAndDisableField(Dialog.form.Pieces);
            Q.isEmptyOrNull(Dialog.form.SKU.value) ? Dialog.form.HasBom.value == false ? q.showAndEnableField(Dialog.form.Weight) : q.showAndDisableField(Dialog.form.Weight) : q.showAndDisableField(Dialog.form.Weight)
            q.hideEditorTab(Dialog.form.ImageName, false);
            q.showAndDisableField(Dialog.form.UnitLabour);
            q.showAndDisableField(Dialog.form.NetWeight);
            q.showAndDisableField(Dialog.form.WstPer);
            q.showAndDisableField(Dialog.form.WstWt);
            q.showAndDisableField(Dialog.form.Line_No);
            q.showAndDisableField(Dialog.form.Hallmark); 
            q.showAndDisableField(Dialog.form.HUID);
            q.showAndDisableField(Dialog.form.StampId);
            q.showAndDisableField(Dialog.form.MetalId);
            q.showAndDisableField(Dialog.form.KaratId);

            q.hideField(Dialog.form.HasBom);
            q.hideField(Dialog.form.ShapeId);
            q.hideField(Dialog.form.QualityId);
            q.hideField(Dialog.form.StoneColorId);
            q.hideField(Dialog.form.StoneSizeId);
            q.hideField(Dialog.form.SieveId);
            q.hideField(Dialog.form.PointerWeight);
            q.hideField(Dialog.form.StoneCutId);
            q.hideField(Dialog.form.StonePolishId);
            q.hideField(Dialog.form.StoneSymmetryId);
            q.hideField(Dialog.form.StoneFluorescenceId);
            q.hideField(Dialog.form.StoneCuletId);
            q.hideField(Dialog.form.StoneGirdleId);
            q.hideField(Dialog.form.StoneTable);
            q.hideField(Dialog.form.StoneDepth);
            q.hideField(Dialog.form.LotNo);
            q.showAndDisableField(Dialog.form.StampId);

            q.showAndDisableField(Dialog.form.Line_No);
            q.showAndDisableField(Dialog.form.Hallmark);
            q.showAndDisableField(Dialog.form.HUID);
            q.showAndDisableField(Dialog.form.CertificateNo);
            q.showAndDisableField(Dialog.form.Lab);
            q.showAndEnableField(Dialog.form.RefNo);
        }

        q.showAndDisableField(Dialog.form.ProductCode);
        q.showAndDisableField(Dialog.form.ProductName);
        q.showAndDisableField(Dialog.form.ProductTypeId);
        q.showAndDisableField(Dialog.form.HSN);
        q.showAndDisableField(Dialog.form.TaxCode);
        Dialog.element.find('sup').toggle(Dialog.isReadOnly);
        for (let editor in Dialog.form) {
            if (Dialog.form[editor].widgetName) {

                try {
                    Serenity.EditorUtils.setReadOnly(Dialog.form[editor], Dialog.isReadOnly);
                } catch { }
            }
        }
    }

    export function SalesItemFieldsForPD(Dialog: any, VoucherId: number) {
         
        setMF(Dialog);

        //Dialog.form.ProductId.value == undefined ? Dialog.entity.HasBom = false : Dialog.form.HasBom.value = true;
        // **** Hide Jewellery Fields **** //
        if (Dialog.entity.ItemTypeId != 101) {

            Serenity.EditorUtils.setReadonly(Dialog.form.UnitRate.element, false);
            q.hideField(Dialog.form.BOMDetails);
            q.hideField(Dialog.form.BrandId);
            q.hideField(Dialog.form.CollectionId);
            q.hideField(Dialog.form.SuperTypeId);
            q.hideField(Dialog.form.ProductSizeId);
            q.hideField(Dialog.form.UnitLabour);
            q.hideField(Dialog.form.NetWeight);
            q.hideField(Dialog.form.DiamondPieces);
            q.hideField(Dialog.form.DiamondWeight);
            q.hideField(Dialog.form.StonePieces);
            q.hideField(Dialog.form.StoneWeight);
            q.hideField(Dialog.form.OtherWeight);
            q.hideField(Dialog.form.OtherPieces);
            q.hideField(Dialog.form.StoneRate);
            q.hideField(Dialog.form.OtherRate);
            q.hideField(Dialog.form.WstPer);
            q.hideField(Dialog.form.WstWt);
            q.hideField(Dialog.form.Line_No);
            q.hideField(Dialog.form.SKU);
            q.hideField(Dialog.form.CategoryId);
            q.hideField(Dialog.form.HasBom);
            q.hideField(Dialog.form.Hallmark);
            q.hideField(Dialog.form.HUID);
            q.hideEditorTab(Dialog.form.BOMDetails);
            q.hideEditorTab(Dialog.form.ImageName);
            Dialog.form.HasBom.value == false;

            // **** Metal Fields **** //
            if (Dialog.form.ProductTypeId.value == "5" || Dialog.form.ProductTypeId.value == "6" || Dialog.form.ProductTypeId.value == "7") {
                q.showAndDisableField(Dialog.form.KaratId);
                q.showAndDisableField(Dialog.form.MetalColorId);
                q.showAndDisableField(Dialog.form.Purity);
                q.showAndDisableField(Dialog.form.PureWeight);
                q.hideField(Dialog.form.ShapeId);
                q.hideField(Dialog.form.QualityId);
                q.hideField(Dialog.form.StoneColorId);
                q.hideField(Dialog.form.StoneSizeId);
                q.hideField(Dialog.form.SieveId);
                q.hideField(Dialog.form.PointerWeight);
                q.hideField(Dialog.form.Pieces);
                q.hideField(Dialog.form.SubCategoryId);
                q.hideField(Dialog.form.LotNo);

            }

            // **** Stone Fields **** //
            if (Dialog.form.ProductTypeId.value == "11" || Dialog.form.ProductTypeId.value == "12" || Dialog.form.ProductTypeId.value == "13") {
                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.SubCategoryId) : q.showAndSetRequiredField(Dialog.form.SubCategoryId);
                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ShapeId) : q.showAndSetRequiredField(Dialog.form.ShapeId);
                q.showAndDisableField(Dialog.form.QualityId);
                q.showAndDisableField(Dialog.form.SieveId);
                q.showAndDisableField(Dialog.form.StoneColorId);
                q.showAndDisableField(Dialog.form.StoneSizeId);
                q.showAndDisableField(Dialog.form.LotNo);
                q.showAndEnableField(Dialog.form.PointerWeight);
                q.hideField(Dialog.form.KaratId);
                q.hideField(Dialog.form.MetalColorId);
                q.hideField(Dialog.form.Purity);

                q.showAndEnableField(Dialog.form.Pieces);
                q.showAndEnableField(Dialog.form.Weight);
                q.hideField(Dialog.form.PureWeight)
                q.hideField(Dialog.form.Purity);
                Dialog.form.CalcOnId.value = "5";
                Dialog.form.CalcUnitId.value = "8"

                switch (parseInt(Dialog.form.CategoryId.value)) {
                    case 1:
                    case 3:
                    case 4:
                        q.hideField(Dialog.form.StoneCutId);
                        q.hideField(Dialog.form.StonePolishId);
                        q.hideField(Dialog.form.StoneSymmetryId);
                        q.hideField(Dialog.form.StoneFluorescenceId);
                        q.hideField(Dialog.form.StoneCuletId);
                        q.hideField(Dialog.form.StoneGirdleId);
                        q.hideField(Dialog.form.StoneTable);
                        q.hideField(Dialog.form.StoneDepth);
                        q.hideField(Dialog.form.CertificateNo);
                        break;
                    case 2:
                        q.showAndDisableField(Dialog.form.StoneCutId);
                        q.showAndDisableField(Dialog.form.StonePolishId);
                        q.showAndDisableField(Dialog.form.StoneSymmetryId);
                        q.showAndDisableField(Dialog.form.StoneFluorescenceId);
                        q.showAndDisableField(Dialog.form.StoneCuletId);
                        q.showAndDisableField(Dialog.form.StoneGirdleId);
                        q.showAndDisableField(Dialog.form.StoneTable);
                        q.showAndDisableField(Dialog.form.StoneDepth);
                        q.showAndDisableField(Dialog.form.CertificateNo);
                        q.showAndDisableField(Dialog.form.Pieces);
                        q.showAndDisableField(Dialog.form.Weight);
                        q.showAndDisableField(Dialog.form.Lab);
                        break;
                }

                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.CategoryId) : q.showAndSetRequiredField(Dialog.form.CategoryId);
                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.SubCategoryId) : q.showAndSetRequiredField(Dialog.form.SubCategoryId);
                Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ShapeId) : q.showAndSetRequiredField(Dialog.form.ShapeId);
            }
        }
        else {
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.CategoryId) : q.showAndSetRequiredField(Dialog.form.CategoryId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.SubCategoryId) : q.showAndSetRequiredField(Dialog.form.SubCategoryId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.BrandId) : q.showAndSetRequiredField(Dialog.form.BrandId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.CollectionId) : q.showAndSetRequiredField(Dialog.form.CollectionId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.SuperTypeId) : q.showAndSetRequiredField(Dialog.form.SuperTypeId);
            Dialog.entity.ProductId > 0 ? q.showAndDisableField(Dialog.form.ProductSizeId) : q.showAndSetRequiredField(Dialog.form.ProductSizeId);
            Dialog.entity.ProductId > 0 ? Dialog.form.HasBom.value == true ? q.showAndDisableField(Dialog.form.HasBom) : q.hideField(Dialog.form.HasBom) : q.showAndEnableField(Dialog.form.HasBom);

            Dialog.form.HasBom.value ? q.showFieldAndCategory(Dialog.form.BOMDetails) : q.showFieldAndCategory(Dialog.form.BOMDetails, false);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.Purity) : q.showAndDisableField(Dialog.form.Purity);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.PureWeight) : q.showAndDisableField(Dialog.form.PureWeight);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.HasBom) : q.showAndEnableField(Dialog.form.HasBom);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.StoneWeight) : q.showAndEnableField(Dialog.form.StoneWeight);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.MetalAmount) : q.showAndEnableField(Dialog.form.MetalAmount);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.StoneAmount) : q.showAndEnableField(Dialog.form.StoneAmount);
            Dialog.form.HasBom.value ? q.hideField(Dialog.form.StoneRate) : q.showAndSetRequiredField(Dialog.form.StoneRate);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.DiamondPieces) : q.hideField(Dialog.form.DiamondPieces);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.DiamondWeight) : q.hideField(Dialog.form.DiamondWeight);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.StonePieces) : q.hideField(Dialog.form.StonePieces);
            Dialog.form.HasBom.value ? q.showAndDisableField(Dialog.form.UnitRate) : q.showAndSetRequiredField(Dialog.form.UnitRate);

            Q.isEmptyOrNull(Dialog.form.SKU.value) ? q.showAndEnableField(Dialog.form.Pieces) : q.showAndDisableField(Dialog.form.Pieces);
            Q.isEmptyOrNull(Dialog.form.SKU.value) ? Dialog.form.HasBom.value == false ? q.showAndEnableField(Dialog.form.Weight) : q.showAndDisableField(Dialog.form.Weight) : q.showAndDisableField(Dialog.form.Weight)
            q.hideEditorTab(Dialog.form.ImageName, false);
            q.showAndDisableField(Dialog.form.UnitLabour);
            q.showAndDisableField(Dialog.form.NetWeight);
            q.showAndDisableField(Dialog.form.WstPer);
            q.showAndDisableField(Dialog.form.WstWt);
            q.showAndDisableField(Dialog.form.Line_No);
            q.showAndDisableField(Dialog.form.Hallmark);
            q.showAndDisableField(Dialog.form.HUID);
            q.showAndDisableField(Dialog.form.StampId);
            q.showAndDisableField(Dialog.form.MetalId);
            q.showAndDisableField(Dialog.form.KaratId);

            q.hideField(Dialog.form.HasBom);
            q.hideField(Dialog.form.ShapeId);
            q.hideField(Dialog.form.QualityId);
            q.hideField(Dialog.form.StoneColorId);
            q.hideField(Dialog.form.StoneSizeId);
            q.hideField(Dialog.form.SieveId);
            q.hideField(Dialog.form.PointerWeight);
            q.hideField(Dialog.form.StoneCutId);
            q.hideField(Dialog.form.StonePolishId);
            q.hideField(Dialog.form.StoneSymmetryId);
            q.hideField(Dialog.form.StoneFluorescenceId);
            q.hideField(Dialog.form.StoneCuletId);
            q.hideField(Dialog.form.StoneGirdleId);
            q.hideField(Dialog.form.StoneTable);
            q.hideField(Dialog.form.StoneDepth);
            q.hideField(Dialog.form.LotNo);
            q.showAndDisableField(Dialog.form.StampId);

            q.showAndDisableField(Dialog.form.Line_No);
            q.showAndDisableField(Dialog.form.Hallmark);
            q.showAndDisableField(Dialog.form.HUID);
            q.showAndDisableField(Dialog.form.CertificateNo);
            q.showAndDisableField(Dialog.form.Lab);
            q.showAndEnableField(Dialog.form.RefNo);
        }

        q.hideField(Dialog.form.ProductCode);
        q.hideField(Dialog.form.ProductName);
        q.showAndDisableField(Dialog.form.ProductTypeId);
        q.hideField(Dialog.form.HSN);
        q.hideField(Dialog.form.TaxCode);
    }
}